import {
  Vector3,
  init_math_vector
} from "./chunk-KXFHISWH.mjs";

// src/helpers/Constants.ts
init_math_vector();
var CAMERA_TYPE = /* @__PURE__ */ ((CAMERA_TYPE2) => {
  CAMERA_TYPE2[CAMERA_TYPE2["ARC_ROTATE"] = 0] = "ARC_ROTATE";
  CAMERA_TYPE2[CAMERA_TYPE2["UNIVERSAL"] = 1] = "UNIVERSAL";
  CAMERA_TYPE2[CAMERA_TYPE2["ORTHOGRAPHIC"] = 2] = "ORTHOGRAPHIC";
  return CAMERA_TYPE2;
})(CAMERA_TYPE || {});
var LOAD_TYPE = /* @__PURE__ */ ((LOAD_TYPE2) => {
  LOAD_TYPE2[LOAD_TYPE2["FLOOR"] = 0] = "FLOOR";
  LOAD_TYPE2[LOAD_TYPE2["BUILDING"] = 1] = "BUILDING";
  return LOAD_TYPE2;
})(LOAD_TYPE || {});
var Constants_default = {
  ENABLE_PIPELINE: false,
  DO_NOT_SYNC_BB: true,
  MESH_LAYER_MASK: 268435456,
  VIRTUAL_TOUR_CAMERA_MASK: 536870912,
  CAMERA_3D_LAYER_MASK: 805306368,
  MINIMAP_LAYER_MASK: 1073741824,
  UPPER_BETA_LIMIT: 1.5708,
  PANNING_SENSIBILITY: 175,
  HIGHLIGHT_ALPHA: 3 * Math.PI / 2,
  HIGHLIGHT_BETA: 1.372,
  VIRTUAL_TOUR_CAMERA_SPEED_MULTIPLIER: 0.25,
  CAMERA_DEFAULT_FOV: 0.7,
  VIRTUAL_TOUR_CAMERA_FOV: 1.3,
  ANGULAR_SENSIBILITY_MOBILE: 1e3,
  ANGULAR_SENSIBILITY_DESKTOP: 2e3,
  POINTER_CIRCLE_TEXTURE: "/images/vt-pointer.png",
  POINTER_POSITIONY: 25,
  CONTINUOUS_RENDERING: true,
  MAX_RENDER_TIME: 100,
  ADAPT_TO_DEVICE_RATIO: true,
  POINTER_CIRCLE_SIZE: 0.3,
  CAMERA_3D_VIEW_MINZ: 10,
  CAMERA_3D_VIEW_DEFAULT_VALUES: {
    alpha: 1,
    beta: 1,
    radius: 100,
    target: Vector3.Zero()
  },
  CAMERA_2D_VIEW_DEFAULT_VALUES: {
    alpha: Math.PI / 2,
    beta: 0,
    radius: 60,
    target: Vector3.Zero()
  },
  HIGHLIGHT_ZOOM: 100,
  CAMERA_YOFFSET_PORTRAIT_MOBILE: 2,
  SPACE_VISIBILITY: 0.25,
  SKYBOX_NAME: "SkyBox",
  MINIMAP_PLANE_NAME: "minimapPlane",
  FIRST_PERSON_TARGET_OFFSET: 0.1,
  MINIMAP_CAM_CONE_NAME: "minimapCone",
  CAMERA_2D_CONE_NAME: "camera2DCone",
  CAMERA_2D_CONE_POSITIONY: 3.12,
  UPDATE_PIN_POS_FREQUENCY: 10,
  UPDATE_PIN_VIS_FREQUENCY: 100,
  UPDATE_CARDINAL_DIR_FREQUENCY: 200,
  CAMERA_3D_DEFAULT_RADIUS: 1e3,
  CAMERA_3D_DEFAULT_ZOOM: 0.5,
  CAMERA_SCROLLBAR_LENGTH: 0.96,
  UNAVAILABLE_HIGHLIGHT_COLOR: {
    albedoColor: "#cc141f",
    emissiveColor: "#bc0000"
  },
  BUILDING_FLOOR_VISIBILITY: 0.15,
  SCENE_TIMEOUT_SECONDS: 120,
  DEFAULT_IMAGE_PROCESSING: {
    toneMapping: 0,
    contrast: 1,
    exposure: 1,
    iblIntensity: 1
  },
  HIGHLIGHT_COLOR: "#169462",
  HIGHLIGHT_EDGES_WIDTH: 25
};
var PIN_COLOR = {
  energy: "#51B4FF",
  green_areas: "#4cc66d",
  certifications: "#e9af1b",
  features: "#1CDBCF",
  building: "#4C51C6",
  parking: "#e97e1b",
  health: "#F57A7A",
  meeting_rooms: "#4cc66d",
  relax_and_lounge_areas: "#EAC585",
  phone_booths: "#4cc66d",
  emergency: "#FF1F1F",
  coworking_areas: "#4C51C6",
  support_departments: "#FF9999",
  medical_services: "#FF7033",
  link: "#4286f4",
  uncategorized: ""
};
var MATERIAL_PINS = [
  {
    label: "uncategorized",
    displayName: "Uncategorized",
    materialLabel: "uncategorized",
    className: "material-icons-outlined",
    svg: `<svg></svg>`
  },
  {
    label: "energy",
    displayName: "Energy",
    materialLabel: "bolt",
    className: "material-icons-outlined",
    svg: `<svg xmlns="http://www.w3.org/2000/svg"  height="24px" viewBox="0 0 24 24" width="24px" fill="${PIN_COLOR.energy}"><g><rect fill="none" height="24" width="24"/></g><g><path d="M11,21h-1l1-7H7.5c-0.88,0-0.33-0.75-0.31-0.78C8.48,10.94,10.42,7.54,13.01,3h1l-1,7h3.51c0.4,0,0.62,0.19,0.4,0.66 C12.97,17.55,11,21,11,21z"/></g></svg>`
  },
  {
    label: "green_areas",
    displayName: "Green Areas",
    materialLabel: "park",
    className: "material-icons-outlined",
    svg: `<svg xmlns="http://www.w3.org/2000/svg"  height="24px" viewBox="0 0 24 24" width="24px" fill="${PIN_COLOR.green_areas}"><g><rect fill="none" height="24" width="24"/></g><g><g><g><path d="M17,12h2L12,2L5.05,12H7l-3.9,6h6.92v4h3.95v-4H21L17,12z M6.79,16l3.9-6H8.88l3.13-4.5l3.15,4.5h-1.9l4,6H6.79z"/></g></g></g></svg>`
  },
  {
    label: "certifications",
    displayName: "Certifications",
    materialLabel: "workspace_premium",
    className: "material-icons-outlined",
    svg: `<svg xmlns="http://www.w3.org/2000/svg"  height="24px" viewBox="0 0 24 24" width="24px" fill="${PIN_COLOR.certifications}"><rect fill="none" height="24" width="24"/><path d="M9.68,13.69L12,11.93l2.31,1.76l-0.88-2.85L15.75,9h-2.84L12,6.19L11.09,9H8.25l2.31,1.84L9.68,13.69z M20,10 c0-4.42-3.58-8-8-8s-8,3.58-8,8c0,2.03,0.76,3.87,2,5.28V23l6-2l6,2v-7.72C19.24,13.87,20,12.03,20,10z M12,4c3.31,0,6,2.69,6,6 s-2.69,6-6,6s-6-2.69-6-6S8.69,4,12,4z M12,19l-4,1.02v-3.1C9.18,17.6,10.54,18,12,18s2.82-0.4,4-1.08v3.1L12,19z"/></svg>`
  },
  {
    label: "building",
    displayName: "Building",
    materialLabel: "business",
    className: "material-icons-outlined",
    svg: `<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="${PIN_COLOR.building}"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"/></svg>`
  },
  {
    label: "features",
    displayName: "Features",
    materialLabel: "room_preferences",
    className: "material-icons-outlined",
    svg: `<svg xmlns="http://www.w3.org/2000/svg"  height="24px" viewBox="0 0 24 24" width="24px" fill="${PIN_COLOR.features}"><g><rect fill="none" height="24" width="24"/><path d="M21.69,16.37l1.14-1l-1-1.73l-1.45,0.49c-0.32-0.27-0.68-0.48-1.08-0.63L19,12h-2l-0.3,1.49c-0.4,0.15-0.76,0.36-1.08,0.63 l-1.45-0.49l-1,1.73l1.14,1c-0.08,0.5-0.08,0.76,0,1.26l-1.14,1l1,1.73l1.45-0.49c0.32,0.27,0.68,0.48,1.08,0.63L17,22h2l0.3-1.49 c0.4-0.15,0.76-0.36,1.08-0.63l1.45,0.49l1-1.73l-1.14-1C21.77,17.13,21.77,16.87,21.69,16.37z M18,19c-1.1,0-2-0.9-2-2s0.9-2,2-2 s2,0.9,2,2S19.1,19,18,19z M19,4v6h-2V6h-2v6h-2V5H7v14h5v2H3v-2h2V3h10v1H19z M12,13h-2v-2h2V13z"/></g></svg>`
  },
  {
    label: "parking",
    displayName: "Parking",
    materialLabel: "local_parking",
    className: "material-icons-outlined",
    svg: `<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="${PIN_COLOR.parking}"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M13 3H6v18h4v-6h3c3.31 0 6-2.69 6-6s-2.69-6-6-6zm.2 8H10V7h3.2c1.1 0 2 .9 2 2s-.9 2-2 2z"/></svg>`
  },
  {
    label: "health",
    displayName: "Health",
    materialLabel: "monitor_heart",
    className: "material-icons-outlined",
    svg: `<svg xmlns="http://www.w3.org/2000/svg"  height="24px" viewBox="0 0 24 24" width="24px" fill="${PIN_COLOR.health}"><g><rect fill="none" height="24" width="24"/></g><g><g><path d="M20,4H4C2.9,4,2,4.9,2,6v3h2V6h16v3h2V6C22,4.9,21.1,4,20,4z"/><path d="M20,18H4v-3H2v3c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2v-3h-2V18z"/><path d="M14.89,7.55c-0.34-0.68-1.45-0.68-1.79,0L10,13.76l-1.11-2.21C8.72,11.21,8.38,11,8,11H2v2h5.38l1.72,3.45 C9.28,16.79,9.62,17,10,17s0.72-0.21,0.89-0.55L14,10.24l1.11,2.21C15.28,12.79,15.62,13,16,13h6v-2h-5.38L14.89,7.55z"/></g></g></svg>`
  },
  {
    label: "meeting_rooms",
    displayName: "Meeting Rooms",
    materialLabel: "door_front",
    className: "material-icons-outlined",
    svg: `<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24" fill="${PIN_COLOR.meeting_rooms}"><path d="M120-120v-80h80v-560q0-33 23.5-56.5T280-840h400q33 0 56.5 23.5T760-760v560h80v80H120Zm560-80v-560H280v560h400ZM560-440q17 0 28.5-11.5T600-480q0-17-11.5-28.5T560-520q-17 0-28.5 11.5T520-480q0 17 11.5 28.5T560-440ZM280-760v560-560Z"/></svg>`
  },
  {
    label: "relax_and_lounge_areas",
    displayName: "Relax & Lounge Areas",
    materialLabel: "weekend",
    className: "material-icons-outlined",
    svg: `<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24" fill="${PIN_COLOR.relax_and_lounge_areas}"><path d="M160-680q0-50 35-85t85-35h400q50 0 85 35t35 85v80q50 0 85 35t35 85v200q0 50-35 85t-85 35H160q-50 0-85-35t-35-85v-200q0-50 35-85t85-35v-80Zm80 0v112q18 17 29 39t11 49v80h400v-80q0-27 11-49t29-39v-112q0-17-11.5-28.5T680-720H280q-17 0-28.5 11.5T240-680Zm520 360H200v-160q0-8-3-15.5t-8.5-13q-5.5-5.5-13-8.5t-15.5-3q-17 0-28.5 11.5T120-480v200q0 17 11.5 28.5T160-240h640q17 0 28.5-11.5T840-280v-200q0-17-11.5-28.5T800-520q-8 0-15.5 3t-13 8.5q-5.5 5.5-8.5 13t-3 15.5v160Zm-280 0Zm0 80Zm0-160Z"/></svg>`
  },
  {
    label: "phone_booths",
    displayName: "Phone Booths",
    materialLabel: "call",
    className: "material-icons-outlined",
    svg: `<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="${PIN_COLOR.phone_booths}"><path d="M798-120q-125 0-247-54.5T329-329Q229-429 174.5-551T120-798q0-18 12-30t30-12h162q14 0 25 9.5t13 22.5l26 140q2 16-1 27t-11 19l-97 98q20 37 47.5 71.5T387-386q31 31 65 57.5t72 48.5l94-94q9-9 23.5-13.5T670-390l138 28q14 4 23 14.5t9 23.5v162q0 18-12 30t-30 12ZM241-600l66-66-17-94h-89q5 41 14 81t26 79Zm358 358q39 17 79.5 27t81.5 13v-88l-94-19-67 67ZM241-600Zm358 358Z"/></svg>`
  },
  {
    label: "emergency",
    displayName: "Emergency",
    materialLabel: "fire_extinguisher",
    className: "material-icons-outlined",
    svg: `<svg xmlns="http://www.w3.org/2000/svg"  height="24px" viewBox="0 -960 960 960" width="24px" fill="${PIN_COLOR.emergency}"><path d="M360-80q-33 0-56.5-23.5T280-160v-40h400v40q0 33-23.5 56.5T600-80H360Zm-80-160v-200h400v200H280Zm4-240q10-46 42-86.5t81-59.5q-10-8-18-17.5T375-664l-175-36v-40l175-36q15-29 42.5-46.5T480-840q21 0 40 7t34 19l126-26v240l-127-26q47 19 79.5 57.5T676-480H284Zm196-200q17 0 28.5-11.5T520-720q-1-18-12-29t-28-11q-17 0-28.5 11.5T440-720q0 17 11.5 28.5T480-680Z"/></svg>`
  },
  {
    label: "coworking_areas",
    displayName: "Coworking Areas",
    materialLabel: "desktop_mac",
    className: "material-icons-outlined",
    svg: `<svg xmlns="http://www.w3.org/2000/svg"  height="24px" viewBox="0 -960 960 960" width="24px" fill="${PIN_COLOR.coworking_areas}"><path d="M320-120v-40l80-80H160q-33 0-56.5-23.5T80-320v-440q0-33 23.5-56.5T160-840h640q33 0 56.5 23.5T880-760v440q0 33-23.5 56.5T800-240H560l80 80v40H320ZM160-440h640v-320H160v320Zm0 0v-320 320Z"/></svg>`
  },
  {
    label: "support_departments",
    displayName: "Support Departments",
    materialLabel: "handshake",
    className: "material-icons-outlined",
    svg: `<svg xmlns="http://www.w3.org/2000/svg"  height="24px" viewBox="0 -960 960 960" width="24px" fill="${PIN_COLOR.support_departments}"><path d="M475-160q4 0 8-2t6-4l328-328q12-12 17.5-27t5.5-30q0-16-5.5-30.5T817-607L647-777q-11-12-25.5-17.5T591-800q-15 0-30 5.5T534-777l-11 11 74 75q15 14 22 32t7 38q0 42-28.5 70.5T527-522q-20 0-38.5-7T456-550l-75-74-175 175q-3 3-4.5 6.5T200-435q0 8 6 14.5t14 6.5q4 0 8-2t6-4l136-136 56 56-135 136q-3 3-4.5 6.5T285-350q0 8 6 14t14 6q4 0 8-2t6-4l136-135 56 56-135 136q-3 2-4.5 6t-1.5 8q0 8 6 14t14 6q4 0 7.5-1.5t6.5-4.5l136-135 56 56-136 136q-3 3-4.5 6.5T454-180q0 8 6.5 14t14.5 6Zm-1 80q-37 0-65.5-24.5T375-166q-34-5-57-28t-28-57q-34-5-56.5-28.5T206-336q-38-5-62-33t-24-66q0-20 7.5-38.5T149-506l232-231 131 131q2 3 6 4.5t8 1.5q9 0 15-5.5t6-14.5q0-4-1.5-8t-4.5-6L398-777q-11-12-25.5-17.5T342-800q-15 0-30 5.5T285-777L144-635q-9 9-15 21t-8 24q-2 12 0 24.5t8 23.5l-58 58q-17-23-25-50.5T40-590q2-28 14-54.5T87-692l141-141q24-23 53.5-35t60.5-12q31 0 60.5 12t52.5 35l11 11 11-11q24-23 53.5-35t60.5-12q31 0 60.5 12t52.5 35l169 169q23 23 35 53t12 61q0 31-12 60.5T873-437L545-110q-14 14-32.5 22T474-80Zm-99-560Z"/></svg>`
  },
  {
    label: "link",
    displayName: "Links",
    materialLabel: "link",
    className: "material-icons-outlined",
    svg: `<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="${PIN_COLOR.link}"><path d="M440-280H280q-83 0-141.5-58.5T80-480q0-83 58.5-141.5T280-680h160v80H280q-50 0-85 35t-35 85q0 50 35 85t85 35h160v80ZM320-440v-80h320v80H320Zm200 160v-80h160q50 0 85-35t35-85q0-50-35-85t-85-35H520v-80h160q83 0 141.5 58.5T880-480q0 83-58.5 141.5T680-280H520Z"/></svg>`
  },
  {
    label: "medical_services",
    displayName: "QHSE",
    materialLabel: "medical_services",
    className: "material-icons-outlined",
    svg: `<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="${PIN_COLOR.medical_services}"><path d="M160-80q-33 0-56.5-23.5T80-160v-480q0-33 23.5-56.5T160-720h160v-80q0-33 23.5-56.5T400-880h160q33 0 56.5 23.5T640-800v80h160q33 0 56.5 23.5T880-640v480q0 33-23.5 56.5T800-80H160Zm0-80h640v-480H160v480Zm240-560h160v-80H400v80ZM160-160v-480 480Zm280-200v120h80v-120h120v-80H520v-120h-80v120H320v80h120Z"/></svg>`
  }
];
var MATERIAL_EDITOR_ICON = {
  duplicate: `<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px"><path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"></path></svg>`,
  rotate: `<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px"><path d="M14 12c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2zm-2-9c-4.97 0-9 4.03-9 9H0l4 4 4-4H5c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.51 0-2.91-.49-4.06-1.3l-1.42 1.44C8.04 20.3 9.94 21 12 21c4.97 0 9-4.03 9-9s-4.03-9-9-9z"></path></svg>`,
  delete: `<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px"><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9zm7.5-5-1-1h-5l-1 1H5v2h14V4z"></path></svg>`,
  flip: `<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px"><path d="M8.5 8.62v6.76L5.12 12 8.5 8.62M10 5l-7 7 7 7V5zm4 0v14l7-7-7-7z"></path></svg>`,
  invert: `<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px"><g transform="rotate(90, 12, 12)"><path d="M8.5 8.62v6.76L5.12 12 8.5 8.62M10 5l-7 7 7 7V5zm4 0v14l7-7-7-7z"></path></g></svg>`
};
var PIN_ICON = {
  plus: `<svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M13.0938 6.875C13.0938 7.28516 12.7715 7.57812 12.3906 7.57812H7.70312V12.2656C7.70312 12.6758 7.38086 12.998 7 12.998C6.58984 12.998 6.29688 12.6758 6.29688 12.2656V7.57812H1.60938C1.19922 7.57812 0.90625 7.28516 0.90625 6.9043C0.90625 6.49414 1.19922 6.17188 1.60938 6.17188H6.29688V1.48438C6.29688 1.10352 6.58984 0.810547 7 0.810547C7.38086 0.810547 7.70312 1.10352 7.70312 1.48438V6.17188H12.3906C12.7715 6.17188 13.0938 6.49414 13.0938 6.875Z" fill="white"/>
        </svg>`,
  close: `<svg width="24" height="24" viewBox="0 0 24 24" fill="black" xmlns="http://www.w3.org/2000/svg"><path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"></path></svg>`,
  arrow_right: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M16.01 11H4v2h12.01v3L20 12l-3.99-4z" fill="white"/>
        </svg>`
};

export {
  CAMERA_TYPE,
  LOAD_TYPE,
  Constants_default,
  PIN_COLOR,
  MATERIAL_PINS,
  MATERIAL_EDITOR_ICON,
  PIN_ICON
};
